import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Charly_Title } from '../../../../../utils/EN/Modals/PostModals';

const ModalPostBetcris = () => {
  return (
    <>
      <ModalVideo
        id="charly-post"
        dataText={Charly_Title}
        videoSrc="https://player.vimeo.com/video/579938500?h=3199d3d24e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_CHARLY"
      />
    </>
  );
};

export default ModalPostBetcris;
